import { List, Grid, Badge } from 'antd';
// import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import phone from '../../../assets/images/phone.svg';
import people from 'assets/images/MakeRequest/people.svg';
import health from 'assets/images/MakeRequest/health.svg';
import paction from 'assets/images/MakeRequest/paction.svg';
import family from 'assets/images/MakeRequest/family.svg';
// import market from 'assets/images/MakeRequest/market.svg';
import './Liststyle.less';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import { useGetAlertsNum } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';

// import NotificationBellWhite from '../../../assets/images/notification-bell-white.svg';

function GeneraliSupportList() {
  const data = [
    {
      tittle: 'life.MakeRequest.ContactInformation',
      svg: people,
      text: 'life.MakeRequest.ContactInformationText',
    },
    {
      tittle: 'life.MakeRequest.PolicyOptions',
      svg: health,
      text: 'life.MakeRequest.PolicyOptionsText',
    },
    {
      tittle: 'life.MakeRequest.PaymentArrangement',
      svg: paction,
      text: 'life.MakeRequest.PaymentArrangementText',
    },
    {
      tittle: 'life.MakeRequest.Beneficiaries',
      svg: family,
      text: 'life.MakeRequest.BeneficiariesText',
    },
    // {
    //   tittle: 'life.MakeRequest.ADirectMarketing',
    //   svg: market,
    //   text: 'life.MakeRequest.ADirectMarketingText',
    // },
  ];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const { xl } = useBreakpoint();
  const [paymentCount, setPaymentCount] = useState<number>(0);
  const { token, ready } = useKeycloakReady();
  const [randoms, setRandoms] = useState(Math.random());

  const { shouldFetch: shouldeFetchNum, data: alerts } = useGetAlertsNum(
    'useGetAlertsNum' + randoms,
    token ?? '',
    '01',
  );
  useEffect(() => {
    setRandoms(Math.random());
    shouldeFetchNum(ready);
  }, [ready, shouldeFetchNum]);
  useEffect(() => {
    if (alerts) {
      setPaymentCount(alerts);
    }
  }, [alerts]);
  // const { data: lifeData, error: lifeError } = useLifeFaq();
  const TodetaileEven = (v: string) => {
    if (v == 'life.MakeRequest.ContactInformation') {
      navigate('/ChangeContactInformation');
    } else if (v == 'life.MakeRequest.PolicyOptions') {
      navigate('/ChangePolicyOptions');
    } else if (v == 'life.MakeRequest.PaymentArrangement') {
      navigate('/ChangePaymentArrangement'); // 替换为你的目标链接
    } else if (v == 'life.MakeRequest.Beneficiaries') {
      navigate('/LIBenefiaries');
    } else if (v == 'life.MakeRequest.ADirectMarketing') {
      navigate('');
    }
  };
  return (
    <List
      style={{ background: '#fff', width: '680px' }}
      size="large"
      className={`UpList ${!xl ? 'to-center' : ''}`}
      header={
        <div>
          <span className="headertittle">{t('life.MakeRequest.Uptittle')}</span>
        </div>
      }
      bordered
      dataSource={data}
      renderItem={(item) => (
        <List.Item
          style={{ fontFamily: 'Roboto400', fontSize: '20px', fontWeight: '400', cursor: 'pointer' }}
          onClick={() => {
            TodetaileEven(item.tittle);
          }}
        >
          <div className="itemtittle">
            <div style={{ fontSize: '20px', display: 'flex' }}>
              {/* <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" /> */}
              <img
                alt={item.tittle}
                src={item.svg}
                style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ marginBottom: '12px' }}>{t(item.tittle)}</span>
                <span style={{ fontSize: '15px', fontFamily: 'Roboto400', color: '#6F7072' }}>{t(item.text)}</span>
              </div>
              {item.tittle === 'life.MakeRequest.PaymentArrangement' && <Badge count={paymentCount} offset={[10, 5]} />}
            </div>
            <div>
              <img src={ChevronRight} style={{ margin: '0  10px 0 0', width: '8px', height: '14px' }} />
            </div>
          </div>
          {/* <div>
            <span style={{ fontSize: '15px', fontFamily: 'Roboto400', color: '#6F7072', marginLeft: '35px' }}>
              {t(item.text)}
            </span>
          </div> */}
        </List.Item>
      )}
    />
  );
}
export default GeneraliSupportList;
